import { createActionGroup, props } from '@ngrx/store';
import { PurchaseOrderPayment } from '@interfaces/schema';

/**
 * @description Action group for heartbeat state management.
 * @exports
 */
export const HeartbeatActions = createActionGroup({
  source: 'Heartbeat',
  events: {
    'Send Message': props<{ message: string }>(),
    'Set Purchase Order Payment': props<PurchaseOrderPayment>()
  }
});
